import React from 'react';
import { I18nUtils } from '../../../../../i18n/I18nUtils';
import { PsPage } from '../../../../shared/components/ps-page/PsPage';
import { MachineCreateContent } from './MachineCreateContent';
import { BreadcrumbsManagerInstance } from '../../../../shared/breadcrumbs/BreadcrumbsManager';
import { Breadcrumbs } from '../../../../shared/breadcrumbs/Breadcrumbs';

export class MachineCreateScreen extends React.Component {

    constructor(props) {
        super(props);

        BreadcrumbsManagerInstance.build([
            Breadcrumbs.MY_CONTRACTORS,
            Breadcrumbs.MY_CONTRACTORS_MACHINES,
            Breadcrumbs.MY_CONTRACTORS_MACHINES_ADD,
        ]);

        this.state = {
            breadcrumbs: BreadcrumbsManagerInstance.breadcrumbs(),
        };
    }

    render() {
        const { breadcrumbs } = this.state;

        return (
            <PsPage title={I18nUtils.tr('TR_MI_NUEVA_MAQUINA_PARA_MIS_CONTRATISTAS')} breadcrumbs={breadcrumbs}>
                <MachineCreateContent/>
            </PsPage>
        );
    }
}

MachineCreateScreen.propTypes = {};

MachineCreateScreen.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/my-contractors/machine/form/create/MachineCreateScreen.jsx